var _path, _circle, _path2, _rect, _rect2, _rect3, _circle2, _circle3, _circle4, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3DCameraHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 163,
    viewBox: "0 0 126 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.505 123.396C113.505 133.463 107.894 140.907 98.7531 145.85C89.6014 150.8 76.9308 153.226 62.9024 153.226C48.874 153.226 36.2034 150.8 27.0517 145.85C17.9111 140.907 12.3 133.463 12.3 123.396C12.3 113.3 17.9412 102.717 27.1072 94.6488C36.2688 86.5843 48.9253 81.0578 62.9024 81.0578C76.8795 81.0578 89.536 86.5843 98.6976 94.6488C107.864 102.717 113.505 113.3 113.505 123.396Z",
    fill: "white",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.9012,
    cy: 57.327,
    r: 47.5544,
    fill: "white",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5508 62C26.6493 70.4681 44.2656 75.941 64.1002 75.941C82.3873 75.941 98.7889 71.2888 109.935 63.926",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.2883,
    y: 16.1223,
    width: 41.2275,
    height: 82.4089,
    rx: 20.6138,
    fill: "white",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.3867,
    y: 18.6133,
    width: 37.0256,
    height: 77.4282,
    rx: 18.5128,
    fill: "#444444"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45.8234,
    y: 20.2199,
    width: 34.154,
    height: 74.2144,
    rx: 17.077,
    stroke: "black",
    strokeWidth: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.9009,
    cy: 57.3286,
    r: 14.9524,
    stroke: "#5F5F5F",
    strokeWidth: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.9008,
    cy: 57.3285,
    r: 6.81566,
    fill: "#262626",
    stroke: "#5F5F5F",
    strokeWidth: 0.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.9007,
    cy: 57.3285,
    r: 2.49839,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62.1484,
    y: 43.8145,
    width: 1.50755,
    height: 3.57256,
    rx: 0.753777,
    fill: "#C4C4C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DCameraHelp);
export default __webpack_public_path__ + "static/media/3d-camera-help.4938e347dcbc2180d80a799ea107cdb0.svg";
export { ForwardRef as ReactComponent };